import { render, staticRenderFns } from "./rechargeResult.vue?vue&type=template&id=0ca82c77"
import script from "./rechargeResult.vue?vue&type=script&lang=js"
export * from "./rechargeResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports